import * as React from 'react';
import { Image } from '@cian/ui-kit/image';

import styles from './Thumbnail.css';
import { IImageInfo } from '../../types/newbuilding';

interface IThumbnailProps {
  image: IImageInfo;
}

export const Thumbnail: React.FC<React.PropsWithChildren<IThumbnailProps>> = ({ image, children }) => {
  return (
    <div className={styles['thumbnail']} data-testid="Thumbnail">
      {/*
        preloader={false}: иначе Image на SSR рендерит инлайн-SVG спиннер ~4 КБ в каждую миниатюру (75 на страницу).
        loading="lazy": 75 миниатюр не должны стартовать вместе с LCP-картинкой и занимать канал на первых секундах.
      */}
      <Image
        src={image.thumbnailUrl || image.fullUrl}
        objectFit="cover"
        borderRadius={0}
        preloader={false}
        loading="lazy"
      />
      {children}
    </div>
  );
};
